import React from "react";
import Header from "@/components/header";
import Footer from "@/components/footer";
import dynamic from "next/dynamic";

// Import brand components dynamically with SSR disabled to avoid framer-motion issues
const BrandFeatures = dynamic(() => import("@/components/brand-features"), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-100 animate-pulse rounded"></div>,
});

const BrandFaq = dynamic(() => import("@/components/brand-faq"), {
  ssr: false,
  loading: () => <div className="h-64 bg-gray-100 animate-pulse rounded"></div>,
});

const BrandDemo = dynamic(() => import("@/components/brand-demo"), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-100 animate-pulse rounded"></div>,
});

import Head from "next/head";
import Link from "next/link";
import { CursorIcon } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { titleAnimate, titleInitial } from "@/components/animations";
import { Button } from "@/components/ui/button";
import MapBackground from "@/components/map-background";

// Force SSR to avoid framer-motion static generation issues
export async function getServerSideProps() {
  return { props: {} };
}

export default function Brands() {
  return (
    <div>
      <Head>
        <title>Partbot - Automotive Product Information Management (PIM)</title>
      </Head>
      <Header />

      <main>
        <MapBackground />
        <div className="relative flex min-h-[90dvh] flex-col items-end justify-end pt-24">
          <div className="container mx-auto">
            <div className="relative sm:overflow-hidden">
              <div className="mt:py-16 wrap-balance relative px-6 py-6 xl:px-6">
                <motion.h1
                  initial={titleInitial}
                  whileInView={titleAnimate()}
                  viewport={{ once: true }}
                  className="text-balance bg-linear-to-r pb-5 text-4xl font-bold leading-none drop-shadow-lg text-stone-50 lg:text-6xl xl:text-7xl lg:max-w-6xl"
                >
                  Manage Your Automotive Product Data & Stockist Network
                </motion.h1>
                <motion.p
                  initial={titleInitial}
                  whileInView={titleAnimate(0.5)}
                  viewport={{ once: true }}
                  className="mt-3 max-w-prose text-balance text-lg text-emerald-300/75 md:mt-6"
                >
                  Catalogue your automotive parts, connect to your website and
                  sync to ecommerce merchants. Manage your stockist network and
                  control how your products are presented and sold online.
                </motion.p>
                <div className="mt-9">
                  <Button className="bg-emerald-500" asChild>
                    <Link href="/contact">
                      <span className="mr-3">Request a demo</span>
                      <CursorIcon />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BrandDemo />
        <BrandFeatures />
        <BrandFaq />
      </main>

      <Footer />
    </div>
  );
}
